export default {
    showCar: false,
    default: 0,
    goodsId: '',
    istab: 0,
    orderInfo: {},
    isAddress: false,
    isAdd: false,
    addrsesInfo: {}
}


// WEBPACK FOOTER //
// ./src/store/states.js